<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        巡查记录详情
      </div>
    </div>
    <!-- <unitList @select="getUnit" @getFirst='getOne'></unitList> -->
    <div class="flex1 record-content">
      <div class="header">
        <div class="item" v-for="(item, key) in headerOptions">
          <span class="width120">{{ item }} </span>{{ detailData[key] }}
        </div>
      </div>
      <el-table :data="detailData.middleList" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
        <el-table-column prop="checkBig" label="" width="120" align="center"> </el-table-column>
        <el-table-column prop="checkSmall" label="巡查内容"> </el-table-column>
        <el-table-column prop="amount1" label="结果">
          <template slot-scope="scope">
            {{ scope.row.abnormal ? "异常" : "正常" }}
          </template>
        </el-table-column>
        <el-table-column prop="location" label="位置"> </el-table-column>
        <el-table-column prop="patrolData" label="巡查数据"> </el-table-column>
        <el-table-column prop="childList" width="300px" label="照片">
          <template slot-scope="scope">
            <div v-if="scope.row.childList.length > 0" v-for="item of scope.row.childList">
              <div>
                <strong>图片编号：{{ item.photoNum }}</strong>
              </div>
              <div>拍摄时间：{{ item.photoTime }}</div>
              <div>拍摄内容：{{ item.photoContent }}</div>
              <div>文字描述：{{ item.photoDescribe }}</div>
              <div>备注：{{ item.remark }}</div>
              <div>
                <img :src="item.photoUrl" alt="" />
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-form v-if="false" ref="form" v-model="form" label-width="80px" :rules="rules" class="mt20">
      <el-col :span="12">
        <el-form-item label-width="160px" prop="" label="巡查日期:">
          <!-- <el-input v-model="form.submissionTime"></el-input> -->
          {{ form.submissionTime }}
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label-width="160px" prop="" label="巡查范围">
          <!-- <el-input v-model="form.c_nfc"></el-input> -->
          {{ form.inspectionScope }}
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label-width="160px" prop="" label="巡查人">
          <!-- <el-input v-model="form.c_point_basic"></el-input> -->
          {{ form.nickName }}
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label-width="160px" prop="" label="巡查方法">
          <!-- <el-input v-model="form.c_nfc"></el-input> -->
          {{ form.inspectionMethod }}
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label-width="160px" prop="" label="巡查原因">
          <!-- <el-input v-model="form.c_point_basic"></el-input> -->
          {{ form.inspectionReason }}
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="form.state !== '0'">
        <el-form-item v-if="$route.query.view" label-width="160px" prop="" label="状态">
          <el-button type="info" size="mini">{{ $map.checkstates[form.state] }}</el-button>
        </el-form-item>
      </el-col>

      <el-col class="ml20" :span="24" style="margin-bottom: 20px">
        <div class="ml20">
          <el-button class="ml20" type="primary" @click="linktoZF">执法记录仪<i class="ml10 el-icon-right"></i></el-button>
        </div>
      </el-col>

      <table v-if="false" class="table table-bordered" style="margin-top: 20px" id="basicTable">
        <thead>
          <th style="height: 50px; width: 20%">巡查内容</th>
          <th style="height: 50px; width: 15%">结果</th>

          <th style="height: 50px; width: 15%">位置</th>

          <th style="height: 50px; width: 15%">数量</th>

          <th style="height: 50px; width: 30%">照片</th>
        </thead>
        <tbody>
          <tr v-for="item in form.wenwuInspectionAppChildren">
            <td>{{ item.checklist }}</td>
            <td>{{ item.checked == 1 ? "有" : "无" }}</td>
            <td>{{ item.location }}</td>
            <td>{{ item.count }}</td>
            <td>
              <img v-for="it in item.fileList" :src="it" @click="showImg(it)" alt="" class="ml20" style="height: 100px" />
            </td>
          </tr>
          <tr>
            <td>极端天气记录</td>
            <td colspan="4">{{ form.extremeWeatherRecord }}</td>
          </tr>
          <tr>
            <td>总体评价</td>
            <td colspan="4">{{ form.overallEvaluation }}</td>
          </tr>
          <tr>
            <td>保护对策与基数建议</td>
            <td colspan="4">{{ form.technicalAdvice }}</td>
          </tr>
          <tr>
            <td>备注</td>
            <td colspan="4">{{ form.remark }}</td>
          </tr>
        </tbody>
      </table>

      <!-- <el-row :gutter="20" class="mt20">
        <el-col :span="12">
          <el-row> </el-row>
          <el-row>
            <el-form-item label-width="160px" prop="" label="巡查点编号">
              <el-input v-model="form.c_point_number"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label-width="160px" prop="" label="巡查点名称">
              <el-input v-model="form.c_point_name"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="巡查点位置">
              <el-input v-model="form.c_point_number"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="是否异常">
              <el-radio v-model="form.c_point_error" :label="1">是</el-radio>
              <el-radio v-model="form.c_point_error" :label="0">否</el-radio>
              <el-radio v-model="form.c_point_error" :label="2"
                >当场整改</el-radio
              >
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="巡查结果描述">
              <el-input
                type="textarea"
                v-model="form.c_point_error_desc"
              ></el-input>
            </el-form-item>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-form-item label-width="160px" prop="" label="巡查点设备">
              <el-input v-model="form.c_point_basic"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="NFC编号">
              <el-input v-model="form.c_nfc"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="上报人员">
              <el-input v-model="form.c_commit_name"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="创建时间">
              <el-input v-model="form.c_commit_time"></el-input>
            </el-form-item>
            <el-form-item
              v-if="$route.query.view"
              label-width="160px"
              prop=""
              label="状态"
            >
              <el-button type="info" size="mini">{{
                $map.checkstates[form.c_point_states]
              }}</el-button>
            </el-form-item>
          </el-row>
        </el-col>
      </el-row> -->
      <!-- <el-row>
        <el-form-item
          label-width="160px"
          prop=""
          label="现场照片"
          v-for="item in form.imgList"
          :key="item"
        >
          <img class="ml20 mt20" :src="item" alt="" style="" /> </el-form-item
      ></el-row> -->
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item
            label-width="160px"
            prop=""
            label="现场照片"
            v-if="form.imgList && form.imgList.length"
          >
            <img
              class="ml20 mt20"
              v-for="item in form.imgList"
              :key="item"
              :src="item"
              alt=""
              style="max-height: 390px"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label-width="160px"
            prop=""
            label="整改后照片"
            v-if="form.imgbackList && form.imgbackList.length"
          >
            <img
              class="ml20 mt20"
              v-for="item in form.imgbackList"
              :key="item"
              :src="item"
              alt=""
              style="max-height: 390px"
            />
          </el-form-item>
        </el-col>
      </el-row> -->
    </el-form>

    <div v-if="form.inspectionType == 2 && form.state == 2" class="btn-box flex1 center" style="margin-bottom: 40px">
      <el-button type="danger" @click="changestatus(1)" v-if="!$route.query.view">通过</el-button>
      <el-button type="primary" @click="changestatus(2)" v-if="!$route.query.view">复核</el-button>
      <el-button type="primary" @click="$router.back()">返回</el-button>
      <el-button type="success" @click="downFiles">下载文档</el-button>
    </div>
    <div v-else class="btn-box flex1 center" style="margin-bottom: 40px">
      <el-button type="primary" @click="$router.back()">返回</el-button>
      <el-button type="success" @click="downFiles" :loading="isDownLoad">下载文档</el-button>
    </div>
    <el-dialog :visible.sync="showImage" width="90%" :show-close="true">
      <div class="center">
        <img :src="viewImg" alt="" width="70%" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import {buildList} from './options'
// import {addCompany, editCompany} from "../../api/company";
// import {getArea} from "../../api/common";
import { getSafeList } from "../../api/safety";
import { resolveBlob } from "../../utils/download";
import axios from "axios";

export default {
  data() {
    return {
      headerOptions: {
        builderName: "文物建筑名称：",
        roadNameDoorplate: "路名门牌：",
        inspectionDate: "巡查日期：",
        inspectionScope: "巡查范围：",
        nickName: "巡查人：",
        inspectionMethod: "巡查方法：",
        extremeWeatherRecord: "极端天气记录：",
      },
      isDownLoad: false, // 下载按钮加载
      detailData: {},
      pos: 0,
      spanArr: [],
      id: this.$route.query.id || "",
      form: {},
      rules: {},
      showImage: false,
      viewImg: "",
      radio: "",
      CheckedKeys: [],
      props: {
        label: "111",
        children: "zo11nes",
      },
      list2: [],
      list: [],
    };
  },
  created() {
    if (this.id) {
      this.getList();
    }
  },
  mounted() {},

  methods: {
    showImg(it) {
      this.viewImg = it;
      this.showImage = true;
    },
    addtime() {
      if (this.form.get_rate.length < 2) {
        this.form.get_rate.push({
          m_start_time: "",
          m_end_time: "",
          m_rate: "",
        });
      } else {
        this.form.get_rate.splice(1);
      }
    },
    linktoZF() {
      window.open("https://trzhidui.tongren119.com/#/login", "_blank");
    },
    downFiles() {
      // axios({
      //   method: "post",
      //   url: "/inspection/wenwuInspectionAppMain/exportArchives",
      //   responseType: "blob",
      //   data: this.form,
      //   headers: { Authorization: "Bearer " + this.$local.get("token") },
      // }).then((res) => {
      //   this.resolveBlob(
      //     res,
      //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      //   );
      // });
      this.isDownLoad = true;
      this.downLoadWord("/inspection/wenwuInspectionAppMain/exportArchives", this.form, "post", () => {
        this.isDownLoad = false;
      });
      // this.$post('/inspection/wenwuInspectionAppMain/exportArchives',this.form).then(res=>{
      //   console.log(res)
      //   this.resolveBlob(res,'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
      // })
    },

    resolveBlob(res, mimeType) {
      const aLink = document.createElement("a");
      var blob = new Blob([res.data], { type: mimeType });
      // //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
      var patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
      // var contentDisposition = decodeURI(res.headers['content-disposition'])
      // var result = patt.exec(contentDisposition)
      // var fileName = result[1]
      // fileName = fileName.replace(/\"/g, '')
      aLink.style.display = "none";
      aLink.href = URL.createObjectURL(blob);
      aLink.setAttribute("download", this.form.pointNum + "巡查详情报告"); // 设置下载文件名称
      document.body.appendChild(aLink);
      aLink.click();
      URL.revokeObjectURL(aLink.href); //清除引用
      document.body.removeChild(aLink);
      console.log(aLink);
    },

    getList() {
      this.loading = true;
      this.$get(`/inspection/wenwuInspectionAppMain/getInfoAttached`, {
        id: this.id,
      }).then((res) => {
        console.log(111111);
        this.detailData = res.data;
        this.detailData.middleList.push({ checkBig: "其他" });
        this.ergodicData(this.detailData.middleList);

        this.form = res.data;
        res.data.wenwuInspectionAppChildren?.map((item) => {
          item.fileList = item.inspectionPhotosUrl.split(",");
        });
      });
    },
    //通过不通过

    changestatus(stae) {
      // var c_point_states = stae ? 3 : 4;

      this.$post("/inspection/wenwuInspectionAppMain/click", {
        // c_log_id: this.form.c_log_id,
        // c_point_states,

        click: stae,
        id: this.form.id,
      }).then((res) => {
        // this.$message.success("操作成功");
        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        this.getList();
      });
    },
    //合并行前数据整理 tableData 就是请求下来的数据
    ergodicData(tableData) {
      for (var i = 0; i < tableData.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断本次和上一次的 comprehensiveName 值是否相等
          if (tableData[i].checkBig === tableData[i - 1].checkBig) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == this.spanArr.length - 1) {
        if (columnIndex === 0) {
          return {
            rowspan: 1,
            colspan: 10,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      } else if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container-list {
  padding: 0 20px;
  flex-direction: column;
}
.record-content {
  .header {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 12px;
    .item {
      font-size: 16px;
    }
    .width120 {
      text-align: right;
      padding-right: 12px;
      width: 120px;
      display: inline-block;
    }
  }
}
.tree {
  font-size: 18px;
}
.table-bordered {
  border: 1px solid #dddddd;
}
.table {
  width: 100%;
}

.table > tbody > tr > td,
.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > thead > tr > th {
  padding: 8px;
  height: 100px;
  overflow: auto;
  vertical-align: center;
  text-align: center;
  border-top: 1px solid #ddd;
}
.table-bordered > thead > tr > th,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > tbody > tr > td,
.table-bordered > tfoot > tr > td {
  border: 1px solid #dddddd;
}
</style>
